<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-12">
				<h2 class="mb-4">{{__('lang.my_account.add_article')}}</h2>
				<div class="form-row">
					<div class="form-group col-12">
						<b-form-radio-group @change="resetInputs" stacked v-model="selected" :options="options" name="add_own_article" ></b-form-radio-group>
					</div>
				</div>
				<!-- Add existing User Article -->
				<div v-if="selected == 1">


					<div class="form-group col-12 col-md-6">
							<!-- <label class="col-form-label col-form-label-sm required" for="articlelist">
								{{input.placeholder}}
							</label> -->
							<b-form-select class="col-form-label col-form-label-sm" v-model="designation" :options="userarticles_options" id="articlelist" >
								<template v-slot:first>
									<b-form-select-option :value="null" disabled>{{__('lang.ownarticle_select_one')}}</b-form-select-option>
								</template>
							</b-form-select>
							<!-- :state="designationselected" -->

					</div>
				</div>

				<!-- Create New User Article -->
				<div v-if="selected == 2">
					<div class="form-row">
						<b-form-group class="form-group col-12 col-md-6" :label="label.number" label-for="number" label-class="col-form-label col-form-label-sm text-secondary required" :invalid-feedback="numberInvalidFeedback" :state="numberState"> <b-form-input type="text" class="form-control border" v-model="input.number" id="number" required="required" :state="numberState"></b-form-input> </b-form-group>
						<b-form-group class="form-group col-12 col-md-6" :label="label.designation" label-for="designation" label-class="col-form-label col-form-label-sm text-secondary required" :invalid-feedback="designationInvalidFeedback" :state="designationState"> <b-form-input type="text" class="form-control border" v-model="input.designation" id="designation" required="required" :state="designationState"></b-form-input> </b-form-group>
					</div>
					<div class="form-row">
						<b-form-group class="form-group col-12 _col-md-6" :label="label.description" label-for="description" label-class="col-form-label col-form-label-sm text-secondary" :invalid-feedback="descriptionInvalidFeedback" :state="descriptionState"> <textarea class="form-control border" v-model="input.description" id="description" :state="descriptionState"></textarea> </b-form-group>
					</div>
					<div class="form-row">
						<b-form-group class="form-group col-12 col-md-6" :label="label.price" label-for="price" label-class="col-form-label col-form-label-sm text-secondary"> <b-form-input type="number" class="form-control border" v-model="input.price" id="price" step="0.01"></b-form-input> </b-form-group>
						<b-form-group class="form-group col-12 col-md-6" :label="label.discount" label-for="discount" label-class="col-form-label col-form-label-sm text-secondary"> <b-form-input type="number" class="form-control border" v-model="input.discount" id="discount" step="0.01"></b-form-input> </b-form-group>
					</div>
					<div class="form-row">
						<b-form-group class="form-group col-12 col-md-6" :label="label.article_group" label-for="article_group" label-class="col-form-label col-form-label-sm text-secondary" :invalid-feedback="article_groupInvalidFeedback" :state="article_groupState"> <b-form-input type="text" class="form-control border" v-model="input.article_group" id="article_group" :state="article_groupState"></b-form-input> </b-form-group>
					</div>
				</div>
				<div class="form-row my-4">
					<div class="form-group col-12 col-md-6 order-2 order-md-1">
						<button type="reset" class="btn btn-gray-50 text-white btn-block border-0" data-dismiss="modal">
							<svg class="icon">
								<use xlink:href="/assets/img/icon-sprite.svg#global.form.reset" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
							</svg>
							{{__('lang.my_account.abort')}}
						</button>
					</div>
					<div class="form-group col-12 col-md-6 order-1 order-md-2">
						<button type="button" class="btn btn-primary btn-block border-0" @click="submit">
							<svg class="icon">
								<use xlink:href="/assets/img/icon-sprite.svg#global.form.send" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
							</svg>
							{{__('lang.my_account.apply')}}
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import globalsApi from './services/api/globals'
/* import materialApi from './services/api/material'
import log from './services/logger/index' */

export default {
	data() {
		return {
			label:{
				number: this.__('lang.my_account.article_number'),
				designation: this.__('lang.my_account.designation'),
				description: this.__('lang.my_account.description'),
				price: this.__('lang.my_account.price_vat'),
				discount: this.__('lang.my_account.discount_percent'),
				article_group: this.__('lang.my_account.article_group'),

			},
			input: {
				number: '',
				designation: '',
				description: '',
				price: null,
				discount: null,
				article_group: '',
				placeholder: this.__('lang.ownarticle_select_one'),
			},

			selected: 1,
			designation: null,
			attempt_submit: false,
			options: [
				{ text: this.__('lang.ownarticle.add_exists_article'), value: 1 },
				{ text: this.__('lang.ownarticle.add_new_article'), value: 2 }
				],
			userarticles_options: [],

    	}
    },

    methods: {
		submit() {

			if (this.selected == 1) {
				this.addArticle()

				document.getElementById('closeOwnArticleCreateModal').click();
			} else {
				this.attempt_submit = true;
				console.log('this.attempt_submit')
				console.log(this.designationState)
				console.log(this.numberState)
				console.log(this.article_groupState)
				console.log(this.descriptionState)


				if(this.designationState && this.numberState && (this.article_groupState || this.article_groupState == null) && this.descriptionState){
					this.createArticle()
					this.designation = null
					this.selected = 1

					document.getElementById('closeOwnArticleCreateModal').click();
				}
			}

			//this.resetInputs()
			/* this.designation=null
			this.selected=1 */

		},
		resetInputs(){
			this.attempt_submit = false;
			/* var self = this;
			console.log('resetInputsbdgbd:')
			Object.keys(this.input).forEach(function(key,index) {
				console.log(key)
				self.input[key] = '';
			}); */
			this.designation=null
			this.input.number=''
			this.input.designation=''
			this.input.description=''
			this.input.price=''
			this.input.discount=''
			this.input.article_group=''

		},


		async createArticle() {


			var response = await globalsApi.createArticles(this.input);

   			if (response.status >= 400 ){
				this.$store.dispatch('alert/setAlert', {type: 'danger', message: this.__('lang.alert.ownarticle_not_created')})
  			}else{
				console.log('createArticle')
				var new_article={}
				new_article['flag_fan']=''
                new_article['ref_no']=this.input.number
                new_article['version']=''
                new_article['type']=this.input.designation
                new_article['quantity']=1
                new_article['discount_1']=this.input.discount>0? parseFloat(this.input.discount):0
                new_article['discount_2']= 0
                new_article['price']=(this.input.price>0?parseFloat(this.input.price):0).toFixed(2)
                new_article['listprice']=(this.input.price>0?parseFloat(this.input.price):0).toFixed(2)
                new_article['positiontext']=''
                new_article['image']=''
                new_article['description_short']=this.input.description
                new_article['product_source']=2
				new_article['position'] = this.shoppingcartlist.length
				new_article['productmarker'] = 0

				this.shoppingcartlist.push(new_article)
				//this.getUserArticles()
				this.$store.dispatch('alert/setAlert', {type: 'success', message: this.__('lang.alert.ownarticle_added')})
  			}
        },
        addArticle() {
    		var articles =JSON.parse(JSON.stringify(this.user.articles))
    		var found_article= articles.find(article => article.designation == this.designation)

			/* if(this.designation == null){
				this.$store.dispatch('alert/setAlert', {type: 'danger', message: this.__('lang.ownarticle_select_one')})
				return
			}
			else found_article= articles.find(article => article.designation == this.designation)
           	*/
    		if(found_article == null) {
				this.$store.dispatch('alert/setAlert', {type: 'danger', message: this.__('lang.alert.ownarticle_not_found')})
				return
			}

    		/* var articleAdded = this.shoppingcartlist.find(article => article.ref_no == found_article.number)
    		if(articleAdded) {
    			articleAdded['quantity']++
    		} else { */
                found_article['flag_fan']=''
                found_article['ref_no']=found_article.number
                found_article['version']=''
                found_article['type']=found_article.designation
                found_article['quantity']=1
                found_article['discount_1']= found_article.discount??0;
                found_article['discount_2']= 0;
                found_article['price']= (found_article.price>0?parseFloat(found_article.price):0).toFixed(2)
                found_article['listprice']=(found_article.price>0?parseFloat(found_article.price):0).toFixed(2)
                found_article['positiontext']=''
                found_article['image']=''
                found_article['description_short']=found_article.description
				found_article['product_source'] = 2
				found_article['productmarker'] = 0
        		this.shoppingcartlist.push(found_article)
    		/* } */
        },
		async getUserArticles() {
			if (!this.user.auth) {
				return
			}
			this.userarticles_options=[]
  			var response = await globalsApi.returnUserArticles(this.user);
			console.log('getUserArticles response :')
	  		console.log(response)
	  		this.user.articles = response.data
			this.user.articles.forEach(function(e){
				this.userarticles_options.push({
					value: e.designation, text: e.number+' - '+e.designation
				})
			}.bind(this))

        },
	},
    computed: {
		designationselected() {
			return !!(this.designation && this.designation.length > 0);
		},
		numberState() {
			if(!this.attempt_submit) return null
			if(this.input.number.length >= 255) return false
			return this.input.number.length >= 1
	    },
	    numberInvalidFeedback() {
	    	if(!this.attempt_submit) return null
			if(this.input.number.length >= 255) return this.__('lang.my_account.max_lenght_exceeded')
	    	else return this.__('my_account.input_value')
        },
        designationState() {
			if(!this.attempt_submit) return null
			if(this.input.designation.length >= 255) return false
			return this.input.designation.length >= 1
	    },
	    designationInvalidFeedback() {
	    	if(!this.attempt_submit) return null
			if(this.input.designation.length >= 255) return this.__('lang.my_account.max_lenght_exceeded')
	    	else return this.__('my_account.input_value')
        },
        descriptionState() {
        	if(!this.attempt_submit) return null
			return this.input.description.length < 255
	    },
	    descriptionInvalidFeedback() {
	    	return this.__('lang.my_account.max_lenght_exceeded')
        },
        article_groupState() {
        	if(!this.attempt_submit || this.input.article_group.length == 0) return null
        	return this.input.article_group.length < 255
	    },
	    article_groupInvalidFeedback() {
	    	return this.__('lang.my_account.max_lenght_exceeded')
        },
        shoppingcartlist:{
              get() {
                return this.$store.state.shoppingcart.shoppingcartlist
              },
              set(value) {
                 this.$store.commit('shoppingcart/updateShoppingcartList', value)
              }
        },
    	user: {
    		get () {
                console.log('OwnArticle');
                console.log(this.$store.state.user.user);
                return this.$store.state.user.user
    		},
		    set (value) {
  		      	this.$store.commit('user/updateUser', value)
  		    }
    	},

    },
   watch: {
          '$store.state.user.user': {
              immediate: true,
              deep:true,
              handler() {
                this.user=this.$store.state.user.user
              }
          },
    },
    created() {
		this.getUserArticles()
		this.selected=1
    },

}
</script>
